'use client';

import { useAuth } from '@/hooks/useAuth';
import { useAtom } from 'jotai';
import { errorAtom } from '@/lib/store';
import LoginForm from '../components/LoginForm';
import SprintPlanning from '../components/SprintPlanning';
import Logo from '../assets/planora_logo.svg';

export default function Home() {
  const { isAuthenticated } = useAuth();
  const [error] = useAtom(errorAtom);

  return (
    <main className="min-h-screen">
      {!isAuthenticated ? (
        <div className="p-4 md:p-8 flex flex-col items-center h-full">
          <div className="max-w-6xl mx-auto p-6">
            <div className="flex flex-col items-center mb-8">
              <div className="w-sm h-auto">
                <Logo />
              </div>
            </div>

            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6 max-w-md mx-auto">
                <p>{error}</p>
              </div>
            )}

            <LoginForm />
          </div>
        </div>
      ) : (
          <SprintPlanning />
      )}
    </main>
  );
}